import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery';
import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.min.css';
import AccountNavbar from '../components/AccountNavbar'
import PatientProfileDetails from '../components/PatientProfileDetails'
import MembershipInformation from '../components/MembershipInformation'
import CommercialMedicalInsurance from '../components/CommercialMedicalInsurance'
import PharmacyInsuranceInformation from '../components/PharmacyInsuranceInformation'
import PatientEnrollmentDetails from '../components/PatientEnrollmentDetails'

export default function Profile() {

	return (
		<div className="container" id="content" style={{ fontSize: '1em' }}>

			<div id="container" className="rtx_prof">
				<div id="hcp_post_content">
					<AccountNavbar page="profile" />
					<div className="clearfloat"></div>
					<div className="formBox">
						<PatientProfileDetails />
						<MembershipInformation />
					</div>
					<CommercialMedicalInsurance />
					<PharmacyInsuranceInformation />
					<PatientEnrollmentDetails />
					<div className="clearfloat"></div>
				</div>
			</div>
		</div>
	)
}